import { Get, Put } from '../helpers';
import { TicketSetMember, PaidListsResponse } from '@/types/registration.types';

export const GetPaidLists = (channel: number): Promise<PaidListsResponse> => {
  return Get({
    path: `/v3/admin/paid-lists/${channel}`,
    authRequired: true,
  });
};

export const GetPaidListMembers = (
  paidList: string,
  offset: number
): Promise<{ members: TicketSetMember[]; total: number | null }> => {
  return Get({
    path: `/v3/admin/paid-lists/members/${paidList}/${offset}`,
    authRequired: true,
  });
};

export const SearchPaidListMembers = (paidList: string, offset: number, search: string): Promise<TicketSetMember[]> => {
  return Get({
    path: `/v3/admin/paid-lists/members/search/${paidList}/${offset}?search=${search}`,
    authRequired: true,
  });
};

export const AddPaidListMember = (paidList: string, email: string): Promise<TicketSetMember> => {
  return Put({
    path: `/v3/admin/paid-lists/members/${paidList}`,
    body: { email },
    authRequired: true,
  });
};

export const AddPaidListMemberMultiple = (
  paidList: string,
  url: string
): Promise<{ added: number; invalid: string[] }> => {
  return Put({
    path: `/v3/admin/paid-lists/members/multiple/${paidList}`,
    body: { url },
    authRequired: true,
  });
};
